import React, {useState} from "react"
import {Box, Typography} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    lessonTitle: {
        marginBottom: theme.spacing(2),
        backgroundColor: "#F17632",
        borderRadius: "10px",
        color: "#fff",
        width: "100%",
        padding: "15px 4px",
        textAlign: "center",
    },
    questionContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    questionCard: {
        width: "100%",
        maxWidth: "800px",
        minWidth: "800px",
        minHeight: "200px",
        padding: theme.spacing(2),
        margin: theme.spacing(2),
        backgroundColor: '#F3F1EC !important',
        border: '2px dotted #0097a7',
        borderRadius:'30px !important',
    },
    navButton: {
        backgroundColor: "#F17632 !important",
        color: "#fff !important",
        "&:hover": {
            backgroundColor: "#D65F2B !important",
        },
    },
    prevButton: {
        marginRight: theme.spacing(2),
    },
    nextButton: {
        marginLeft: theme.spacing(2),
    },
    disabledButton: {
        backgroundColor: "#ccc !important",
    },
}));

const ProgramLearningContent = ({ selectedLesson }) => {
    const classes = useStyles();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [visibleStartIndex, setVisibleStartIndex] = useState(0);
    const visibleSlideCount = 4; // Adjust based on available space

    const handlePrevSlide = () => {
        if (currentSlide > 0) setCurrentSlide(currentSlide - 1);
    };

    // const handleNextSlide = () => {
    //     if (currentSlide < sessionsData.length - 1) setCurrentSlide(currentSlide + 1);
    // };

    const handlePrevNav = () => {
        if (visibleStartIndex > 0) setVisibleStartIndex(visibleStartIndex - 1);
    };

    // const handleNextNav = () => {
    //     if (visibleStartIndex + visibleSlideCount < sessionsData.length) setVisibleStartIndex(visibleStartIndex + 1);
    // };

  return (
      <>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Typography variant="h5" className={classes.lessonTitle}>
                  {selectedLesson.title}
              </Typography>
              <div style={{ backgroundColor: '#F3F1EC', padding: '20px', width: '100%', position: 'relative', marginTop: '40px', border: '2px dotted #0097a7', borderRadius:'30px', }}>
                  <Typography variant="body1" style={{marginTop: '10px', textAlign:'left', color: '#525252'}}>
                      This section contains a series of slides that align with the learning objectives of the lesson. These slides are fully customizable, meaning you can edit or delete them to fit your lesson plan. This flexibility allows you to ensure the content is relevant and engaging for your students.                  </Typography>
              </div>

              {/*<Box sx={{ display: 'flex', alignItems: 'center', marginTop: 3, gap: 1 }}>*/}
              {/*    {visibleStartIndex > 0 && (*/}
              {/*        <IconButton onClick={handlePrevNav}><ArrowBack /></IconButton>*/}
              {/*    )}*/}
              {/*    {sessionsData.slice(visibleStartIndex, visibleStartIndex + visibleSlideCount).map((_, index) => (*/}
              {/*        <Button*/}
              {/*            key={visibleStartIndex + index}*/}
              {/*            variant={currentSlide === visibleStartIndex + index ? "contained" : "outlined"}*/}
              {/*            onClick={() => setCurrentSlide(visibleStartIndex + index)}*/}
              {/*        >*/}
              {/*            Slide {visibleStartIndex + index + 1}*/}
              {/*        </Button>*/}
              {/*    ))}*/}
              {/*    {visibleStartIndex + visibleSlideCount < sessionsData.length && (*/}
              {/*        <IconButton onClick={handleNextNav}><ArrowForward /></IconButton>*/}
              {/*    )}*/}
              {/*</Box>*/}
              {/*<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', width: '100%', height: '100%', position: 'relative', textAlign: 'center' }}>*/}
              {/*    {sessionsData[currentSlide] && (() => {*/}
              {/*        const SlideComponent = PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE[sessionsData[currentSlide].layout];*/}
              {/*        const slideOptions = sessionsData[currentSlide].options;*/}
              {/*        return <SlideComponent*/}
              {/*            data={data}*/}
              {/*            options={{ ...options, ...slideOptions }}*/}
              {/*            actions={actions}*/}
              {/*            {...sessionsData[currentSlide].content_data}*/}
              {/*            backgroundColor={slideOptions?.backgroundColor || '#000'}*/}
              {/*            height={slideOptions?.height}*/}
              {/*            showButton={slideOptions?.showButton}*/}
              {/*        />*/}
              {/*    })()}*/}
              {/*</Box>*/}

          </Box>
      </>
  )
}

export default ProgramLearningContent;